var _circle, _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRecurringV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "url(#paint0_linear_5689_1184)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7343 3.2755C11.1344 3.16829 11.5457 3.40573 11.6529 3.80583L12.1741 5.75103C12.2813 6.15113 12.0439 6.56239 11.6438 6.66959L9.69857 7.19081C9.29847 7.29802 8.88722 7.06058 8.78001 6.66048C8.67716 6.27662 8.89153 5.8825 9.26243 5.75646C8.87934 5.54024 8.43544 5.41662 7.96123 5.41662C6.70048 5.41662 5.65432 6.29164 5.39904 7.44742C5.30971 7.85188 4.90941 8.10735 4.50494 8.01802C4.10048 7.92868 3.84501 7.52838 3.93434 7.12391C4.34066 5.28428 5.99328 3.91662 7.96123 3.91662C8.84102 3.91662 9.65772 4.19021 10.3279 4.65636L10.204 4.19406C10.0968 3.79396 10.3342 3.3827 10.7343 3.2755ZM11.3334 7.24995C11.7476 7.24995 12.0834 7.58574 12.0834 7.99995C12.0834 10.2633 10.2296 12.0833 7.96123 12.0833C7.00176 12.0833 6.11782 11.7582 5.41669 11.2126V11.3333C5.41669 11.7475 5.08091 12.0833 4.66669 12.0833C4.25248 12.0833 3.91669 11.7475 3.91669 11.3333L3.91669 9.33328C3.91669 8.91907 4.25248 8.58328 4.66669 8.58328H6.66669C7.08091 8.58328 7.41669 8.91907 7.41669 9.33328C7.41669 9.7475 7.08091 10.0833 6.66669 10.0833H6.4103C6.84427 10.3975 7.38022 10.5833 7.96123 10.5833C9.4176 10.5833 10.5834 9.41853 10.5834 7.99995C10.5834 7.58574 10.9191 7.24995 11.3334 7.24995Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5689_1184",
    x1: -6.28643e-8,
    y1: 9.00001,
    x2: 16,
    y2: 9.00001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58C463"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37B185"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurringV2);
export default __webpack_public_path__ + "static/media/recurring-v2.7d15d1bf9a3c645c521cddc4725f3126.svg";
export { ForwardRef as ReactComponent };